import { FamilyApplicationResp, isTaxIncomeFlag } from '@/apis/family_application/requests.ts'
import { ATTESTATION_STATUS } from '@/app/pages/family_application/utils.ts'
import { FAMILY_APPLICATION_URLS } from '@/routing/route_paths.ts'
import { findMissingRequiredKeys, isEmpty } from './step-checker.utils'
import { RequiredApplicationData, ValidatedStep } from './step_checker'

export function validateIncomeVerification(
  application: FamilyApplicationResp,
): ValidatedStep {
  const step: ValidatedStep = {
    urls: [],
    status: 'completed',
    missingFields: [],
  }

  if (application.skip_income_verification) {
    step.status = 'warning'
    return step
  }

  const missingInhabitantsKeys = findMissingRequiredKeys(
    application,
    RequiredApplicationData[FAMILY_APPLICATION_URLS.income_verification.index]
  )

  if (!isEmpty(missingInhabitantsKeys)) {
    step.status = 'not_completed'
    step.urls.push(FAMILY_APPLICATION_URLS.income_verification.index)
    step.missingFields.push(...missingInhabitantsKeys)
  }

  const missingEarnersKeys = findMissingRequiredKeys(
    application,
    RequiredApplicationData[FAMILY_APPLICATION_URLS.income_verification.filing_status]
  )
  if (!isEmpty(missingEarnersKeys)) {
    step.status = 'not_completed'
    step.urls.push(FAMILY_APPLICATION_URLS.income_verification.filing_status)
    step.missingFields.push(...missingEarnersKeys)
  }

  const missingIncomeEvaluatedBy = !application.income_evaluated_by

  if (missingIncomeEvaluatedBy) {
    step.status = 'not_completed'
    step.urls.push(FAMILY_APPLICATION_URLS.income_verification.social_security_number)
    step.missingFields.push('income_evaluated_by')
  }

  const missingIncomeAttestation = application.attestations.filter(
    (att) => att.code === 'income'
  )
  const hasAcceptedAll = missingIncomeAttestation.every(
    (att) => att.status === ATTESTATION_STATUS.CONFIRMED
  )
  const skipAttestations = application.income_evaluated_by === 'dws'
  if (!hasAcceptedAll && !skipAttestations) {
    step.status = 'not_completed'
    step.urls.push(FAMILY_APPLICATION_URLS.income_verification.attestations)
    step.missingFields.push('dws')
  }

  const hasUnresolvedIncomeFlags = application.flags.some((flag) => {
    return isTaxIncomeFlag(flag.flag_code) && flag.status !== 'Resolved'
  })

  if (hasUnresolvedIncomeFlags) {
    step.status = 'not_completed'
    step.urls.push(FAMILY_APPLICATION_URLS.review_application)
  }

  return step
}